/*
 * File: d:\projects\AutoFiFront\src\Content\Home\Engagements\Engagements.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Wednesday March 8th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 20th November 2023 11:17:42
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React from 'react';
import style from 'Content/Home/Engagements/Engagements.module.css';
import TextBox from 'Content/TextBox/TextBox';
import Transparency from 'Content/SVG/EngagementSVG/Transparency';
import Knowledge from 'Content/SVG/EngagementSVG/Knowledge';
import Serenity from 'Content/SVG/EngagementSVG/Serenity';
import Price from 'Content/SVG/EngagementSVG/Price';
import ButtonAlt from 'Theme/Component/ButtonAlt';
import translator from 'MultiLanguage/TranslationWrapper';
import { useNavigate } from 'react-router-dom';
import RouterPathResolver from 'Config/Router/RouterPathResolver';

function Engagements(){
    const itemsToDisplay = [
        {
            title:"knowledge",
            text:"knowledgeText",
            icon:<Knowledge fill={"var(--theme-color)"} />
        },
        {
            title:"transparency",
            text:"transparencyText",
            icon:<Transparency fill={"var(--theme-color)"} />
        },
        {
            title:"serenity",
            text:"serenityText",
            icon:<Serenity fill={"var(--theme-color)"} />
        },
        {
            title:"price",
            text:"priceText",
            icon:<Price fill={"var(--theme-color)"} />
        }
    ];
    const navigate = useNavigate();
    const goto = ()=>{
        const url = RouterPathResolver.routeAbout.path;
        navigate(url);
    };

    return(
        <React.Fragment>
            <div className={`${style.engagementsHolder}`}>
                {
                    itemsToDisplay.map((item,index) => { return <TextBox key={item.title+index} icon={item.icon} title={item.title} text={item.text} />})
                }
            </div>
            {/* <ButtonAlt onClick={goto} maxWidth={"50%"}>{translator.decode("aboutUs.knowMore")}</ButtonAlt> */}
        </React.Fragment>
    );
}

export default Engagements;
